import styled from 'styled-components';

interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'danger' | 'success' | 'outline';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  disabled?: boolean;
}

const getButtonStyles = (variant: string = 'primary') => {
  switch (variant) {
    case 'primary':
      return `
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        border: none;
        &:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
        }
      `;
    case 'secondary':
      return `
        background: white;
        color: #374151;
        border: 1px solid #d1d5db;
        &:hover:not(:disabled) {
          background: #f9fafb;
        }
      `;
    case 'danger':
      return `
        background: #dc2626;
        color: white;
        border: none;
        &:hover:not(:disabled) {
          background: #b91c1c;
        }
      `;
    case 'success':
      return `
        background: #059669;
        color: white;
        border: none;
        &:hover:not(:disabled) {
          background: #047857;
        }
      `;
    case 'outline':
      return `
        background: transparent;
        color: #667eea;
        border: 1px solid #667eea;
        &:hover:not(:disabled) {
          background: #667eea;
          color: white;
        }
      `;
    default:
      return `
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        border: none;
      `;
  }
};

const getSizeStyles = (size: string = 'medium') => {
  switch (size) {
    case 'small':
      return `
        padding: 6px 12px;
        font-size: 0.875rem;
      `;
    case 'large':
      return `
        padding: 16px 32px;
        font-size: 1.1rem;
      `;
    default:
      return `
        padding: 12px 24px;
        font-size: 0.95rem;
      `;
  }
};

export const Button = styled.button<ButtonProps>`
  ${props => getButtonStyles(props.variant)}
  ${props => getSizeStyles(props.size)}
  
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: ${props => props.fullWidth ? '100%' : 'auto'};
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none !important;
    box-shadow: none !important;
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
  }
`;